import { render } from "./taking.vue?vue&type=template&id=95e727e0&scoped=true"
import script from "./taking.vue?vue&type=script&lang=js"
export * from "./taking.vue?vue&type=script&lang=js"

import "./taking.vue?vue&type=style&index=0&id=95e727e0&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e727e0"]])

export default __exports__